/*
 * @author        joseph.murphy@zumper.com
 * @copyright     Copyright (c) 2023, Zumper
 * @description   nr file ported over to nr-utils
 */

import { IS_BROWSER, createSettingInterface, getLiveEnv } from '@zcode/settings'
import invariant from 'tiny-invariant'
import { Setting } from './constants'

const { createSetting, freeze } = createSettingInterface()

const zumperMode = getLiveEnv('ZUMPER_MODE')
export const ZUMPER_RENTALS_REDIRECTS = getLiveEnv('ZUMPER_RENTALS_REDIRECTS') === 'true'

export const BLDG_BASE_URL = 'apartment-buildings'
export const NZR_BLDG = `/${BLDG_BASE_URL}`
export const NZR_BLDG_SEP = 'apartments-at'

export const MAPBOX_STYLE_KEY_Z4 =
  'mapbox://styles/zumpermaps/ckqwuarar5e4a17rrndqwjoko?optimize=true'
export const MAPBOX_STYLE_KEY_Z4_DARK =
  'mapbox://styles/zumpermaps/cl8kkt15k000814o29wq3gs1o?optimize=true'

export const APTS_BASE_URL = 'apartments-for-rent'
const _APP_HOSTNAME = createSetting(
  Setting.APP_HOSTNAME,
  getLiveEnv('APP_HOSTNAME', IS_BROWSER ? window.location.hostname : undefined)
)
invariant(_APP_HOSTNAME, 'APP_HOSTNAME is required')
export const APP_HOSTNAME = _APP_HOSTNAME
export const DEBUG = createSetting(Setting.DEBUG, zumperMode !== 'prod')
export const IMAGE_STATIC_CDN_URL = createSetting(
  Setting.IMAGE_STATIC_CDN_URL,
  process.env.REACT_APP_IMAGE_STATIC_CDN_URL
)

export const MAPBOX_BROWSER_KEY_Z4 =
  'pk.eyJ1IjoienVtcGVybWFwcyIsImEiOiJjazBjbjVsaTcwMHd3M2RudnhybnVzcnNjIn0.5HKqxkHzXm1FGmdrXixmTw'

export const MEDIA_CDN_URL = createSetting(
  Setting.MEDIA_CDN_URL,
  getLiveEnv('REACT_APP_MEDIA_CDN_URL')
)
export const INTERNAL_VIDEO_CDN_URL = createSetting(
  Setting.INTERNAL_VIDEO_CDN_URL,
  getLiveEnv('REACT_APP_INTERNAL_VIDEO_CDN_URL')
)

const _STATIC_CDN_URL = createSetting(Setting.STATIC_CDN_URL, process.env.REACT_APP_STATIC_CDN_URL)
invariant(_STATIC_CDN_URL, 'STATIC_CDN_URL is required')
export const STATIC_CDN_URL = _STATIC_CDN_URL

export const STORAGE_PREFIX = createSetting(
  Setting.STORAGE_PREFIX,
  getLiveEnv('REACT_APP_STORAGE_PREFIX')
)

export const imageStaticUrl = (path: string) => {
  // @ts-expect-error Operator '>=' cannot be applied to types 'string' and 'number'. ts(2365)
  const p = path >= 0 ? path : String(path).replace(/^\/+/, '')
  return `${IMAGE_STATIC_CDN_URL}/${p}`
}

export const mediaUrl = (path: number | string, mediaSize?: '1280x960' | 'full') => {
  const parts = [MEDIA_CDN_URL, String(path).replace(/^\/+/, '')]
  if (mediaSize) {
    parts.push(mediaSize)
  }
  return parts.join('/')
}

export const staticUrl = (path: string) => {
  // @ts-expect-error Operator '>=' cannot be applied to types 'string' and 'number'. ts(2365)
  const p = path >= 0 ? path : String(path).replace(/^\/+/, '')
  return `${STATIC_CDN_URL}/${p}`
}

freeze()
